var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('main',{staticClass:"owner_main_area main_area_pc"},[_c('CompleteStep',{attrs:{"step":"1"}}),_vm._v(" "),(_vm.isConfirm)?_c('Confirm'):_c('Register')],1)}
var staticRenderFns = []

export { render, staticRenderFns }